import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { Locale, Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { ToTuiCountryIsoCodePipe } from './to-tui-country-iso-code.pipe';

@Pipe({
  name: 'toTuiCountryIsoCodes',
  standalone: true,
})
export class ToTuiCountryIsoCodesPipe implements PipeTransform {
  private readonly toTuiCountryIsoCodePipe = new ToTuiCountryIsoCodePipe();

  public transform(codes: Maybe<readonly Locale[]>): readonly TuiCountryIsoCode[] {
    return codes
      ? codes
        .map(code => this.toTuiCountryIsoCodePipe.transform(code))
        .filter(Boolean) as readonly TuiCountryIsoCode[]
      : [];
  }
}
